import React, { useState } from "react";
import Layout from "../../shared/Layout/Layout";
import leftArrow from "../../assets/leftArrow.svg";
import Card1 from "../../components/_forgot/Card1/Card1";
import Card2 from "../../components/_forgot/Card2/Card2";
import { useNavigate } from "react-router-dom";
import styles from "./Forgot.module.scss";

const Forgot = () => {
  const [stage, setStage] = useState(0);
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div
            className={styles.leftArrow}
            onClick={() => {
              stage === 1 ? setStage(0) : navigate("/auth/login");
            }}
          >
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Forgot password?</h1>

          {stage === 0 ? <Card1 setStage={setStage} /> : <Card2 />}
        </div>
      </div>
    </Layout>
  );
};

export default Forgot;
